import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { logout } from '../../service/auth'
import { updatePassword } from '../../api/user'

import styles from './AccountSettings.module.css'

const EMPTY = { current_password: '', new_password: '', confirm_password: '' }

const SecuritySection = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [form, setForm] = useState(EMPTY)
  const [errors, setErrors] = useState({})
  const [status, setStatus] = useState('')
  const [busy, setBusy] = useState(false)

  const set = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }))
    setStatus('')
  }

  const save = (e) => {
    e.preventDefault()
    const next = {}
    if (!form.current_password) next.current_password = 'Enter your current password'
    if (form.new_password.length < 6) next.new_password = 'Use at least 6 characters'
    if (form.confirm_password !== form.new_password)
      next.confirm_password = 'The two new passwords do not match'
    setErrors(next)
    if (Object.keys(next).length) return
    setBusy(true)
    updatePassword(form)
      .then(() => {
        setForm(EMPTY)
        setStatus('Password changed')
      })
      .catch(() => setErrors({ current_password: 'That is not your current password' }))
      .finally(() => setBusy(false))
  }

  const field = (key, label, autoComplete) => (
    <label className={styles.label}>
      {label}
      <input
        className={`${styles.input} ${errors[key] ? styles.bad : ''}`}
        type="password"
        value={form[key]}
        onChange={set(key)}
        autoComplete={autoComplete}
      />
      {errors[key] ? <span className={styles.fieldError}>{errors[key]}</span> : null}
    </label>
  )

  return (
    <section id="security" className={styles.card} aria-labelledby="security-title">
      <h2 id="security-title" className={styles.h2}>
        Password and sign-in
      </h2>
      <p className={styles.lead}>Change your password, or sign out of Morsel.</p>
      <form onSubmit={save} noValidate>
        <div className={styles.grid3}>
          {field('current_password', 'Current password', 'current-password')}
          {field('new_password', 'New password', 'new-password')}
          {field('confirm_password', 'New password again', 'new-password')}
        </div>
        <div className={styles.row} style={{ marginTop: 18, justifyContent: 'space-between' }}>
          <button type="button" className={styles.btn} onClick={() => logout(navigate)(dispatch)}>
            Sign out
          </button>
          <span className={styles.row}>
            {status ? (
              <span className={styles.saved} role="status">
                {status}
              </span>
            ) : null}
            <button className={styles.btnPrimary} disabled={busy}>
              Change password
            </button>
          </span>
        </div>
      </form>
    </section>
  )
}

export default SecuritySection
